module.exports = __webpack_public_path__ + "img/success.c7a10550.png";